// created by wangshuyi on 2022/9/16

'use strict';

//plugin

//component
// 公共组件
import DolIconButton from './common/dol-icon-button.vue';

import DolList from './display/dol-list';
import DolTree from './display/dol-tree';
import DolCard from './display/dol-card';
import DolDict from './display/dol-dict.vue';
import DolImagePreview from './display/dol-image-preview.vue';
import DolSwitchLang from './common/dol-switch-lang';
import DolButton from './common/dol-button';
import DolDrawer from './feedback/dol-drawer';

// 表单
import DolForm from './form/dol-form.vue';
import DolQueryForm from './form/dol-query-form.vue';
import DolQueryFormFilter from './form/dol-query-form-filter.vue';
import DolEditForm from './form/dol-edit-form.vue';

// 表单组件
import DolSelect from './form/dol-select';
import DolRadio from './form/dol-radio.vue';
import DolCheckbox from './form/dol-checkbox.vue';
import DolTreeSelect from './form/dol-tree-select';
import DolUpload from './form/dol-upload';
import DolUploadImg from './form/dol-upload-img';
import DolUploadImgList from './form/dol-upload-img-list';
import DolImport from './form/dol-import.vue';
import DolDate from './form/dol-date';
import DolTime from './form/dol-time.vue';

export {
  // 公共组件
  DolIconButton,

  DolList,
  DolTree,
  DolCard,
  DolDict,
  DolImagePreview,
  DolSwitchLang,
  DolButton,
  DolDrawer,

  DolForm,
  DolQueryForm,
  DolQueryFormFilter,
  DolEditForm,

  DolSelect,
  DolRadio,
  DolCheckbox,
  DolTreeSelect,
  DolUpload,
  DolUploadImg,
  DolUploadImgList,
  DolImport,
  DolDate,
  DolTime,
};

export default {
  install(app) {
    // 公共组件
    app.component(DolIconButton.name, DolIconButton);

    app.component(DolList.name, DolList);
    app.component(DolTree.name, DolTree);
    app.component(DolCard.name, DolCard);
    app.component(DolDict.name, DolDict);
    app.component(DolImagePreview.name, DolImagePreview);
    app.component(DolSwitchLang.name, DolSwitchLang);
    app.component(DolButton.name, DolButton);
    app.component(DolDrawer.name, DolDrawer);

    // 表单
    app.component(DolForm.name, DolForm);
    app.component(DolQueryForm.name, DolQueryForm);
    app.component(DolQueryFormFilter.name, DolQueryFormFilter);
    app.component(DolEditForm.name, DolEditForm);

    // 表单项
    app.component(DolSelect.name, DolSelect);
    app.component(DolRadio.name, DolRadio);
    app.component(DolCheckbox.name, DolCheckbox);
    app.component(DolTreeSelect.name, DolTreeSelect);
    app.component(DolUpload.name, DolUpload);
    app.component(DolUploadImg.name, DolUploadImg);
    app.component(DolUploadImgList.name, DolUploadImgList);
    app.component(DolImport.name, DolImport);
    app.component(DolDate.name, DolDate);
    app.component(DolTime.name, DolTime);
  }
};
